import { type ComponentProps } from 'react'

import { FormControl } from './form'
import { Textarea } from '../textarea'

export const FormTextarea = (props: ComponentProps<typeof Textarea>) => {
  return (
    <FormControl>
      <Textarea {...props} />
    </FormControl>
  )
}
